/* Predictive Search Custom Element */

class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = document.querySelector('.search-drawer__input');
    if (!this.input) return;

    this.resultsContainer = document.getElementById('PredictiveSearchResults');
    this.limit = parseInt(this.dataset.limit) || 6;
    this._debounceTimer = null;

    this.input.addEventListener('input', () => {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => this.onInput(), 300);
    });
  }

  async onInput() {
    const query = this.input.value.trim();

    if (query.length < 2) {
      if (this.resultsContainer) this.resultsContainer.innerHTML = '';
      return;
    }

    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,article&resources[limit]=${this.limit}`
      );
      const data = await response.json();
      this.renderResults(data.resources.results);
    } catch (error) {
      console.error('Predictive search error:', error);
    }
  }

  renderResults(results) {
    if (!this.resultsContainer) return;

    let html = '';

    if (results.products && results.products.length > 0) {
      html += '<div class="predictive-search__group">';
      html += '<h3 class="predictive-search__group-title">Products</h3>';
      results.products.forEach(product => {
        const imgSrc = product.featured_image && product.featured_image.url
          ? product.featured_image.url
          : (product.image || '');
        const image = imgSrc
          ? `<img src="${imgSrc}" class="predictive-search__item-image" width="48" height="48" loading="lazy" alt="">`
          : '';
        const price = product.price
          ? `$${(parseInt(product.price) / 100).toFixed(2)}`
          : '';
        html += `
          <a href="${product.url}" class="predictive-search__item">
            ${image}
            <div class="predictive-search__item-info">
              <span class="predictive-search__item-title">${product.title}</span>
              ${price ? `<span class="predictive-search__item-price">${price}</span>` : ''}
            </div>
          </a>
        `;
      });
      html += '</div>';
    }

    if (results.collections && results.collections.length > 0) {
      html += '<div class="predictive-search__group">';
      html += '<h3 class="predictive-search__group-title">Collections</h3>';
      results.collections.forEach(collection => {
        html += `<a href="${collection.url}" class="predictive-search__item"><span class="predictive-search__item-title">${collection.title}</span></a>`;
      });
      html += '</div>';
    }

    if (results.articles && results.articles.length > 0) {
      html += '<div class="predictive-search__group">';
      html += '<h3 class="predictive-search__group-title">Articles</h3>';
      results.articles.forEach(article => {
        html += `<a href="${article.url}" class="predictive-search__item"><span class="predictive-search__item-title">${article.title}</span></a>`;
      });
      html += '</div>';
    }

    if (!html) {
      html = '<p class="predictive-search__no-results">No results found</p>';
    }

    this.resultsContainer.innerHTML = html;
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
